import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-4uxqju-MuiSvgIcon-root"
    data-testid="ScheduleIcon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 4.5A2.5 2.5 0 0 1 7 2h10a2.5 2.5 0 0 1 2.5 2.5v13.75a2.5 2.5 0 0 1-1.25 2.165v.022a1.562 1.562 0 0 1-3.094.313H8.844a1.562 1.562 0 0 1-3.094-.313v-.022A2.5 2.5 0 0 1 4.5 18.25ZM5.75 7A1.25 1.25 0 0 1 7 5.75h10A1.25 1.25 0 0 1 18.25 7v6.875a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5Zm3.125-3.75a.625.625 0 0 0 0 1.25h6.25a.625.625 0 0 0 0-1.25zm6.875 15a.625.625 0 0 1 .625-.625h1.25a.625.625 0 0 1 .625.625v.625a.625.625 0 0 1-.625.625h-1.25a.625.625 0 0 1-.625-.625Zm-9.375-.625a.625.625 0 0 0-.625.625v.625a.625.625 0 0 0 .625.625h1.25a.625.625 0 0 0 .625-.625v-.625a.625.625 0 0 0-.625-.625z"
      clipRule="evenodd"
      style={{
        fillOpacity: 1,
        strokeWidth: 1.24999,
      }}
    />
  </svg>
);

export default SvgComponent;
